<template>
  <div class="DrkWhite pa-4">
      <h2 class="subheading green--text">Direct Signatories</h2>
      <v-card class="mt-4">
      <Signatory/>
  </v-card>
  </div>
</template>

<script>
import Signatory from '@/components/Utils/Signatory.vue'
  export default {
    components: {
      Signatory
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>